import Sass from 'sass.js/dist/sass.sync.js'

export async function fromScssToCss(value) {
  if (!value) return ''

  const res = await new Promise((resolve, _reject) => {
    Sass.compile(value, function(res) {
      resolve(res)
    })
  })

  return res.text
}
